import {
  useDelete,
  useFetch,
  usePost,
  useUpdate,
} from "../utilities/react-query";

const webUrlsURL = "/web-twinprocms/web-urls";

export const useGetWebUrlsList = ({ limit, offset, name }: any) => {
  const response: any = useFetch<any[]>(
    `${webUrlsURL}?limit=${limit}&offset=${offset}&name=${name}`
  );
  return {
    ...response,
    data: response?.data ?? {},
  };
};

export const useGetWebUrlDetail = (id: number | string | undefined) => {
  const response: any = useFetch<any[]>(`${webUrlsURL}/${id}`, undefined, {
    enabled: !!id,
  });
  return {
    ...response,
    data: response?.data?.data,
  };
};

export const useGetWebUrlsDropdown = () => {
  const response: any = useFetch<any[]>(`${webUrlsURL}?dropdown`);
  return {
    ...response,
    data: response?.data?.data ?? [],
  };
};

export const useCreateWebUrl = (
  updater?: (oldData: any[], newData: any) => any[]
) => usePost<any[], any>(`${webUrlsURL}/create`, undefined, undefined, updater);

export const useUpdateWebUrl = (id: number | string | undefined) =>
  useUpdate<any, any>(`${webUrlsURL}/${id}/update`);

export const useDeleteWebUrl = () => useDelete<any>(webUrlsURL);
